export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.18-1348.18",
  commitId: "79795a434f4430cfa59d8b55b459bb148cef06d9",
  commitTime: "2026-08-18T13:48:18.000Z",
});
